import { Languages } from 'lucide-react';
import { useParams } from 'react-router-dom';

import { HealthCheckList } from '@/components/health/HealthCheckList';
import { HealthRowActions } from '@/components/health/HealthRowActions';
import { useHealthCheck } from '@/hooks/useHealthCheck';

/**
 * Tour-scoped Translations health view. Lists every entity that doesn't
 * have a translation in one of the languages already in use on this tour.
 * Description/voiceover drift inside existing translations is handled in
 * the Descriptions & Voiceovers tab.
 */
export function TourHealthTranslationsTab() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useHealthCheck('tour', 'translations', id);

  return (
    <HealthCheckList
      data={data?.data}
      isLoading={isLoading}
      IconAllClear={Languages}
      allClearTitle="Every translation present"
      allClearDescription="Every attraction, theme and the tour itself have translations in every known language."
      emptyTitle="No translations to check"
      emptyDescription="Add at least one translation in any language and gaps for the rest will surface here."
      renderRowActions={(row) => <HealthRowActions row={row} />}
    />
  );
}
